/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Carrier_Apply_FailedInputs */

const en_orders_carrier_apply_failed = /** @type {(inputs: Orders_Carrier_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier change could not be applied. Update address/date and retry.`)
};

const es_orders_carrier_apply_failed = /** @type {(inputs: Orders_Carrier_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo aplicar el cambio de transportista. Actualiza direccion o fecha e intenta de nuevo.`)
};

/**
* | output |
* | --- |
* | "Carrier change could not be applied. Update address/date and retry." |
*
* @param {Orders_Carrier_Apply_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_apply_failed = /** @type {((inputs?: Orders_Carrier_Apply_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Apply_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_apply_failed(inputs)
	return es_orders_carrier_apply_failed(inputs)
});